import React from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { usePageHeader } from 'utils/hooks'
import { Container, PageWrapper } from './Blends.styled'
import { BlendsDraftList } from './components/BlendsDraftList/BlendsDraftList'
import { BlendsSavedList } from './components/BlendsDraftList/BlendsSavedList'

export const Blends = () => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'))
  usePageHeader({
    headerTitle: 'Blends',
  })

  return (
    <Container>
      <PageWrapper
        sx={{
          flexDirection: isSmallScreen ? 'column' : 'row',
        }}
      >
        <BlendsDraftList />
        <BlendsSavedList />
      </PageWrapper>
    </Container>
  )
}
